import { hasPermissions } from 'dashboard/helper/permissionsHelper';

export const filterMenuItemsByPermission = (
  items,
  availablePermissions,
  resolveRoute
) => {
  const filterItem = item => {
    const children = item.children?.map(filterItem).filter(Boolean);
    if (item.children && children.length === 0) return null;

    if (
      item.permissions?.length &&
      !hasPermissions(item.permissions, availablePermissions)
    ) {
      return null;
    }

    if (item.to) {
      const requiredPermissions = resolveRoute(item.to).meta.permissions || [];
      if (
        requiredPermissions.length > 0 &&
        !hasPermissions(requiredPermissions, availablePermissions)
      ) {
        return null;
      }
    }

    return children ? { ...item, children } : item;
  };

  return items.map(filterItem).filter(Boolean);
};
